import React from "react";

const Img = ({
    className, src="defaultNoData.png", alt="textImg", ...restProps
}) => {
    return <img className={className} src={src} alt={alt} {...restProps} loading={"lazy"}></img>
}
export {Img};